<template>
  <div class="split-icon float-left">
    <a class="home-split d-block" href="#" @click.prevent="click">
      <img
        :src="splitIconPng"
        class="month-view-cal"
        alt="img"
        v-if="!split || $router.currentRoute.path !== '/daily'"
      />
      <img :src="splitIconPngActive" class="month-view-cal" alt="img" v-else />
    </a>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      splitIconPng: require("../../../assets/img/m_splitScreen.png"),
      splitIconPngActive: require("../../../assets/img/m_splitScreen-active.png")
    };
  },
  computed: {
    ...mapGetters({
      split: "getShowSplitScreenMonthly"
    })
  },
  props: {
    click: Function
  }
};
</script>
